import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

export const Layout = ({ children }) => {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <ScrollToTop />
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main className="relative z-[2]">{children}</main>
      <Footer />
    </ReactLenis>
  );
};
